import FormField from '@components/forms/fields/FormField'
import Link from '@components/common/Link'
import { withCsrfRetry } from '@lib/user'
import { Formik, FormikErrors, FormikHelpers } from 'formik'
import { useMutation } from 'react-query'
import * as Yup from 'yup'
import cx from 'classnames'
import Input from '@components/forms/fields/Input'
import Button from '@components/common/Button'
import { jsonFetcher, ResponseError, UnprocessableEntity } from '@lib/fetcher'

type FormValues = {
  email: string
}

const validationSchema = Yup.object().shape({
  email: Yup.string().required().email().label('E-Mail'),
})

const ForgotPasswordForm = () => {
  const forgotPasswordMutation = useMutation<{ status: string }, Error, { email: string }>((data) =>
    withCsrfRetry(
      jsonFetcher<{ status: string }>('/forgot-password', data, {
        method: 'POST',
      })
    )()
  )

  const handleSubmit = (values: FormValues, actions: FormikHelpers<FormValues>) => {
    forgotPasswordMutation.mutate(values, {
      onError: (error) => {
        if (error instanceof UnprocessableEntity) {
          actions.setErrors(error.getSingleValidationErrors())
        }
      },
    })
  }

  return (
    <Formik
      validationSchema={validationSchema}
      initialValues={{ email: '' }}
      onSubmit={handleSubmit}
    >
      {({ handleSubmit }) =>
        forgotPasswordMutation.isSuccess ? (
          <p className="font-semibold">
            Dir wurde eine E-Mail mit einem Link gesendet, mit welchem du dein Passwort zurücksetzen
            kannst.
          </p>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-9">
            <div className="space-y-3.5">
              <FormField label="E-Mail" name="email">
                <Input type="email" placeholder="E-Mail" />
              </FormField>

              <p>
                Doch noch gefunden? <Link href="/login">Hier</Link> kommst du zurück zum Login.
              </p>
            </div>

            <div className="">
              <Button type="submit" disabled={forgotPasswordMutation.isLoading}>
                absenden
              </Button>
            </div>
          </form>
        )
      }
    </Formik>
  )
}

export default ForgotPasswordForm
